import React from 'react';
import { colors, radii } from '../../theme/tokens';
import Icon from './Icon';

// Shared sub-menu pill style used by every sub-app (car-parts Home/Find/Add,
// client-tracking, profile-match, admin, …) so they all look identical.
// - container: transparent (the page gradient shows through)
// - active: green-on-green (translucent green pill + bright green label)
// - inactive: black pill + light label (good contrast on the dark backdrop)
export const subNavPill = (active) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 7,
  padding: '8px 16px',
  borderRadius: radii.pill,
  fontWeight: 700,
  fontSize: 13.5,
  lineHeight: 1,
  cursor: 'pointer',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  border: active ? '1px solid rgba(47,182,92,0.55)' : `1px solid ${colors.glassBorder}`,
  background: active ? 'rgba(47,182,92,0.20)' : colors.pill,
  color: active ? colors.parGreenBright : colors.text
});

const countBadge = (active) => ({
  marginLeft: 2,
  fontSize: 11,
  fontWeight: 800,
  padding: '1px 7px',
  borderRadius: 999,
  background: active ? 'rgba(47,182,92,0.30)' : colors.surface2,
  color: active ? colors.parGreenBright : colors.textMuted
});

// items: [{ key, label, icon?, active, onClick, count? }]
const SubNav = ({ items = [], align = 'center', style }) => (
  <div
    className="subnav"
    style={{
      display: 'flex',
      justifyContent: align === 'center' ? 'center' : 'flex-start',
      flexWrap: 'wrap',
      gap: 8,
      padding: '12px 16px',
      background: 'transparent',
      ...style
    }}
  >
    {items.map((it) => (
      <button
        key={it.key}
        type="button"
        className="subnav-item"
        onClick={it.onClick}
        aria-current={it.active ? 'page' : undefined}
        style={subNavPill(it.active)}
      >
        {it.icon && (
          <Icon name={it.icon} size={18} color={it.active ? colors.parGreenBright : colors.text} />
        )}
        <span>{it.label}</span>
        {it.count != null && <span style={countBadge(it.active)}>{it.count}</span>}
      </button>
    ))}
  </div>
);

export default SubNav;
